<template>
  <v-app class="pa-0 ma-0" id="mainhomecontainer">
    <v-card height="3830px">
      <!-- <v-overlay v-model="overlay"
            :color= "business.themecolor!=NULL?business.themecolor:'#FE5800'" >
            <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay> -->
      <v-overlay v-model="overlay"
            color= "#FE5800" >
            <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <!-- <v-card-title class="pa-0">
                <v-container style="min-height:100px;" class="">
                    <v-row>
                        <v-col
                        cols="12"
                        md="12"

                        class="text-center "

                        >
                        Welcome to Juzzap
                        <br />
                        <span class style="font-size:16px;">A NEW PARADIGM</span>
                        </v-col>
                    </v-row>
                </v-container>

                <v-row class="pwa-content">
                <v-col cols="12" md="12" class="text-center">
                    <img :src="juzzapLogo" width="100" />
                </v-col>
                </v-row>


      </v-card-title> -->
      <v-card-text>
        <v-row>
          <v-col cols="2" md="2">
            <img :src="logo" height="28" />
          </v-col>
          <v-col cols="10" md="10" class="text-center">
            <h4 class="title">{{$t('zz_edit_food_item')}}</h4>
          </v-col>
        </v-row>
        <v-divider></v-divider>



        <v-form v-model="valid" enctype="multipart/form-data" id="edititem" autocomplete="off">


          <v-row align="center" >
            <v-col cols="12" md="4" class="pb-0">
              <v-row>
                  <v-col cols="9" md="9" class="font-weight-bold pb-0" style="font-size:18px;" >
                    {{$t('zz_show_on_menu')}}
                  </v-col>
                  <v-col cols="3" md="3" class="pb-0">
                    <v-switch label="" v-model="data.showonmenu" color="success"></v-switch>
                  </v-col>
              </v-row>

              <v-row align="center">
                <v-col cols="9" md="9" class="font-weight-bold" style="font-size:18px;" >
                  {{$t('zz_separator')}}
                </v-col>
                <v-col cols="3" md="3">
                  <v-switch label="" v-model="data.sepretor" color="success"></v-switch>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="4" class="pb-0 pt-0" v-if="!data.sepretor">



              <v-row no-gutters justify="space-between" >
                <v-col cols="4" md="12" class="pb-0 text-center statheadings">
                    <span class="statheadings">{{$t('zz_updated')}}<br></span>
                    <span class="statdata">{{data.updated_date}}</span>
                </v-col>
                <v-col cols="4" md="12" class="text-center statheadings">
                    <span class="statheadings">{{$t('zz_created')}}<br></span>
                    <span class="statdata">{{data.created_date}}</span>

                </v-col>
              </v-row>




            </v-col>

            <v-col cols="12" md="4" class="pt-0 pt-md-3" v-if="!data.sepretor">
                  <v-row no-gutters justify="space-between">
                      <v-col cols="4" md="12" class="text-center">
                        <span class="statheadings">{{$t('zz_viewed')}}<br></span>
                        <span class="statdata">{{data.viewed}}</span>
                      </v-col>
                      <v-col cols="4" md="12" class="text-center">
                        <span class="statheadings">{{$t('zz_ordered')}}<br></span>
                        <span class="statdata">{{data.ordered}}</span>
                      </v-col>
                  </v-row>
            </v-col>

          </v-row>

          <v-row>
            <v-col cols="12" md="4" class="pb-0 pt-0">




                <v-expansion-panels
                  v-model="paneldish"
                  multiple
                  class="mt-3"
                  tile>
                  <v-expansion-panel  tile>
                      <v-expansion-panel-header tile style="color:#fe5800;background:transparent;border-bottom:2px solid #fe5800;"><strong >Dish Details</strong>   </v-expansion-panel-header>
                        <v-expansion-panel-content>

                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="data.title"
                                name="title"
                                :label="$t('zz_title')"
                                required
                                v-validate="'required|max:100'"
                                :error-messages="errors.collect('title')"
                                data-vv-name="title"
                              ></v-text-field>
                            </v-col>
                             <v-col cols="12" v-for="(tlang,ind) in translationlanguages" :key="'itmtranstitle-'+tlang">
                               <h5>{{tlang}}</h5>
                              <v-text-field
                                v-model="languagetranslations[tlang].title"
                                name="ttitle[tlang]"
                                :label="$t('zz_title')"

                              ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                v-model="data.subtitle"
                                name="subtitle"
                                :label="$t('zz_sub_title')"
                                required
                                v-validate="'required|max:100'"
                                :error-messages="errors.collect('subtitle')"
                                data-vv-name="subtitle"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" v-for="(tlang,ind) in translationlanguages" :key="'itmtranssubtitle-'+tlang">
                              <h5>{{tlang}}</h5>
                              <v-text-field
                                v-model="languagetranslations[tlang].subtitle"
                                name="tsubtitle[tlang]"
                                :label="$t('zz_sub_title')"

                              ></v-text-field>
                            </v-col>
                          </v-row>

                          <v-row v-if="!data.sepretor">
                            <v-col cols="12" sm="12" md="12"> <h4 class="title">{{$t('zz_about_item')}}</h4></v-col>
                          </v-row>
                          <!-- <v-col cols="12" class="spaced" v-if="!data.sepretor">

                            <div class="tooltip"><img src="https://api.juzzap.com/storage/flags/es.svg" width="30px"> <span class="tooltiptext">España</span></div>
                            <div class="tooltip"><img src="https://api.juzzap.com/storage/flags/gb.svg" width="30px"> <span class="tooltiptext">UK</span></div>
                            <div class="tooltip"><img src="https://api.juzzap.com/storage/flags/de.svg" width="30px"> <span class="tooltiptext">Germany</span></div>
                            <div class="tooltip"><img src="https://api.juzzap.com/storage/flags/se.svg" width="30px"> <span class="tooltiptext">Sweden</span></div>
                            <div class="tooltip"><img src="https://api.juzzap.com/storage/flags/ru.svg" width="30px"> <span class="tooltiptext">Russia</span></div>
                            <div class="tooltip"><img src="https://api.juzzap.com/storage/flags/fr.svg" width="30px"> <span class="tooltiptext">France</span></div>
                            <div class="tooltip"><img src="https://api.juzzap.com/storage/flags/it.svg" width="30px"> <span class="tooltiptext">Italy</span></div>
                            <div class="tooltip"><img src="https://api.juzzap.com/storage/flags/gr.svg" width="30px"> <span class="tooltiptext">Greece</span></div>

                          </v-col> -->
                          <!-- <v-col cols="12" md="12" class="text-center ">
                              <v-btn class="primary" block large @click="translator">Add Translation</v-btn>

                          </v-col> -->
                          <v-row v-if="!data.sepretor">
                            <v-col cols="12" md="12">
                              <!-- <v-textarea v-model="data.description" name="description" label="Description"></v-textarea> -->
                              <editor
                              api-key="kmqk9zj3cswmwgz5j95fcwx8fh4nutj31o7ru7va5lxht7nk"
                              initialValue=""
                              v-model="data.description"
                              :init="editorConfigDescription"
                              ></editor>
                            </v-col>
                            <v-col cols="12" v-for="(tlang,ind) in translationlanguages" :key="'itmtransdescription-'+tlang">
                              <h5>{{tlang}}</h5>
                              <editor
                              api-key="kmqk9zj3cswmwgz5j95fcwx8fh4nutj31o7ru7va5lxht7nk"
                              initialValue=""
                              v-model="languagetranslations[tlang].description"
                              :init="editorConfigDescription"
                              ></editor>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                  </v-expansion-panel>




                </v-expansion-panels>

                <v-card v-if="!data.sepretor" class="mt-3 mb-3" style="color:#fe5800;background:transparent;border-bottom:2px solid #fe5800">
                  <v-row align="center">
                    <v-col cols="6" md="6" sm="6">
                      <h3 class="text-center title " color>{{$t('zz_chilli_spice')}}</h3>
                    </v-col>
                    <v-col cols="6" md="6" sm="6" >
                      <v-row justify="center">
                          <v-col
                              v-for="n in 5"
                              :key="n"
                              cols="auto"
                              align="center" class="pl-1 pr-1">
                              <v-icon :color="data.chillispice>=n?'#fe5800':''" @click="data.chillispice=n">mdi-chili-mild</v-icon>

                          </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="text-right">

                      <v-btn outlined flat tile color="primary" @click="chiliclear" style="font-size:10px;border:none;">{{$t('zz_clear_chilli_spice')}}</v-btn>

                    </v-col>
                  </v-row>
                </v-card>

                <v-expansion-panels
                  v-model="panelphoto"
                  multiple
                  v-if="!data.sepretor"
                  class="mb-3">

                    <v-expansion-panel>
                              <v-expansion-panel-header style="color:#fe5800;background:transparent;border-bottom:2px solid #fe5800;"><strong >{{$t('zz_main_photo')}}</strong>   </v-expansion-panel-header>
                                <v-expansion-panel-content>

                                  <v-row>

                                    <v-col col="12" md="12" sm="12"  v-if="data.image!='' && data.image!='https://api.juzzap.com/'">
                                      <img style="max-width:100%"  :src="data.image"  class="grey lighten-2"  max-height="300"  v-if="uploadmainimg!=null" />
                                      <v-icon class="close" @click="deleltemainImage()">mdi-close-box-outline</v-icon>

                                    </v-col>

                                    <v-col cols="12" md="12" sm="12">
                                      <v-row v-if="mainimguploading">
                                                      <v-col cols="12" class="text-center">
                                                        <v-progress-circular
                                                            indeterminate
                                                            color="primary"
                                                          ></v-progress-circular>
                                                      </v-col>
                                      </v-row>



                                      <Cropper v-show="uploadedimage!=null && uploadedimage!='null' " class="cropper" :src="uploadedimage" @change="onChange"/>



                                      <!--<v-row>
                                        <v-col col="12" md="12" sm="12" v-if="data.image!='https://api.juzzap.com/'">
                                          <img
                                            style="max-width:100%"
                                            :src="data.image"
                                            class="grey lighten-2"
                                            max-height="300"
                                            v-if="image!=null"
                                          />
                                        </v-col>
                                      </v-row>-->
                                      <v-row>
                                        <v-col cols="4" md="4" sm="4" class="text-center mb-5 mt-5" >
                                          <!-- <v-btn color="primary" @click="$refs.file.click()">
                                            <input
                                              type="file"
                                              ref="file"
                                              @change="uploadImage($event)"
                                              accept="image/*"
                                              class="d-none"
                                              id="itemimage"
                                            /> Upload Image
                                          </v-btn> -->
                                          <v-img :src="addphoto" @click="$refs.file.click()">
                                            <input
                                              type="file"
                                              ref="file"
                                              @change="uploadImage($event)"
                                              accept="image/*"
                                              class="d-none"
                                              id="itemimage"
                                            />
                                          </v-img>
                                        </v-col>
                                        <v-col cols="8" md="8" sm="8" class="text-justify">

                                          {{$t('zz_photo_upload_note')}}
                                        </v-col>
                                      </v-row>
                                    </v-col>

                                  </v-row>
                                </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>

                <v-expansion-panels
                  v-if="!data.sepretor"
                  v-model="paneldrink"
                  multiple
                  class="mb-3">
                  <v-expansion-panel>
                    <v-expansion-panel-header style="color:#fe5800;background:transparent;border-bottom:2px solid #fe5800;"><strong >{{$t('zz_drink_item')}}</strong>   </v-expansion-panel-header>
                    <v-expansion-panel-content>

                      <v-row>
                        <v-col cols="12" md="12">

                          <v-autocomplete
                            :label="$t('zz_drink_items')"
                            v-model="drinkitems"
                            name="drinkitems"
                            item-text="name"
                            item-value="id"
                            :items="drinkitm"
                            multiple
                            chips
                            dense
                            outlined
                          ></v-autocomplete>

                        </v-col>

                      </v-row>

                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

            </v-col>

            <v-col cols="12" md="4" class="pb-0 pt-0">



                <v-expansion-panels
                v-model="panelprice"
                multiple
                >
                  <v-expansion-panel class="mb-3">
                      <v-expansion-panel-header style="color:#fe5800;background:transparent;border-bottom:2px solid #fe5800;"><strong >{{$t('zz_price')}}</strong>   </v-expansion-panel-header>
                      <v-expansion-panel-content>

                          <v-row v-if="!data.sepretor">
                            <v-col cols="12">
                              {{$t('zz_price_notice')}}
                              <br>Starter - 5.75
                              <br>Mains - 12.00
                            </v-col>
                          </v-row>

                          <v-row v-if="!data.sepretor">
                            <v-col cols="12" class="text-right">
                                <v-btn color="primary" tile class="ml-auto  font-weight-bold" @click="add"><v-icon class="mr-5">mdi-plus</v-icon>{{$t('zz_add_new')}}</v-btn>
                            </v-col>
                          </v-row>



                          <v-row v-for="(item, index) in courseitem" :key="index" align="center">

                              <v-col cols="4" md="4" >
                                  <!--<v-autocomplete
                                  label="Courses"
                                  v-model="item.id"
                                  :name="'course_id['+index+']'"
                                  item-text="name"
                                  item-value="id"
                                  :items="courses">
                                  </v-autocomplete>-->

                                  <v-combobox
                                  :label="$t('zz_courses')"
                                  v-model="item.course"
                                  :name="'course_id['+index+']'"
                                  item-text="name"
                                  item-value="id"
                                  :items="courses"
                                  ></v-combobox>
                              </v-col>
                              <v-col cols="4" md="4" sm="4">
                                  <v-text-field
                                  type="number"
                                  v-model="item.special"
                                  :name="'special['+index+']'"
                                  :label="$t('zz_discount')">
                                  <!-- <v-icon slot="append" color="primary" v-text="business.currency.icon"></v-icon> -->
                                  </v-text-field>
                              </v-col>
                              <v-col cols="3" md="3" sm="3">
                                  <v-text-field
                                      v-model="item.price"
                                      :name="'price['+index+']'"
                                      :label="$t('zz_price')"
                                      type="number"
                                      >
                                      <!-- <v-icon slot="append" v-text="business.currency.icon"></v-icon> -->
                                  </v-text-field>
                              </v-col>
                              <v-col cols="4" md="4" sm="4">
                                  <v-text-field
                                      v-model="item.size"
                                      :name="'size['+index+']'"
                                      :label="$t('zz_item_size')"
                                      type="text"
                                      :maxlength="12"
                                      >
                                      <!-- <v-icon slot="append" v-text="business.currency.icon"></v-icon> -->
                                  </v-text-field>
                              </v-col>
                              <v-col cols="1" md="1" sm="1" justify="right" align="right">
                                  <v-row class="">
                                      <v-col cols="12" md="12" sm="12">
                                          <a @click="courseitem.splice(index, 1)"><v-icon  style="color:red">mdi-close</v-icon></a>
                                      </v-col>
                                  </v-row>

                              </v-col>

                        </v-row>

                          <!-- <v-row v-for="(item, index) in courseitem" :key="index" align="center">
                            <v-col cols="4" md="4" style="font-size:12px;">

                              {{item.name}}
                                <v-autocomplete
                                    label="Courses"
                                    v-model="item.id"
                                    :name="'course_id['+index+']'"
                                    item-text="name"
                                    item-value="id"
                                    :items="courses">
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="4" md="4" sm="4">
                              <v-text-field
                                style="font-size:12px;text-align:right;"
                                type="number"
                                v-model="item.special"
                                :name="'special['+item.id+']'"
                                label="Special">
                                <v-icon slot="append" color="primary" v-text="business.currency.icon"></v-icon>
                              </v-text-field>
                            </v-col>

                            <v-col cols="4" md="4" sm="4">
                              <v-text-field style="font-size:12px;text-align:right;" type="number" v-model="item.price" :name="'price['+item.id+']'" label="Price">
                                <v-icon slot="append" color="primary" v-text="business.currency.icon"></v-icon>
                              </v-text-field>
                            </v-col>


                          </v-row> -->


                      </v-expansion-panel-content>
                  </v-expansion-panel>







                </v-expansion-panels>

                <v-expansion-panels
                v-model="panelpromotion"
                multiple
                v-if="!data.sepretor"
                >

                  <v-expansion-panel class="mb-3">
                      <v-expansion-panel-header style="color:#fe5800;background:transparent;border-bottom:2px solid #fe5800;"><strong >{{$t('zz_promotion')}}</strong>   </v-expansion-panel-header>
                      <v-expansion-panel-content>

                              <v-btn
                                tile
                                outlined
                                block
                                :color="foodstatus=='Feature'?'primary':'secondary'"
                                class="text-left promotionbtn mb-3"
                                @click="changefoodstatus('Feature')"
                                style="font-size:10px;"
                                height="auto"
                                justify="left"

                              >


                                      <img :src="retImg" width="50" class="mr-3" />

                                    <span >
                                        <strong>{{$t('zz_featured')}}</strong><br>
                                        <span>{{$t('zz_dish_highlighted_by_frame')}}</span>
                                    </span>



                              </v-btn>


                            <v-btn
                              tile
                              outlined
                              block
                              :color="foodstatus=='From Chef'?'primary':'secondary'"
                              class="text-left promotionbtn"
                              @click="changefoodstatus('From Chef')"
                              style="font-size:10px;"
                              height="auto"
                              justify="left"
                            >


                                    <img :src="chefImg" width="50" class="mr-3" />

                                  <span>
                                      <strong>{{$t('zz_chefs_choice')}}</strong><br>
                                      <span>{{$t('zz_dish_highlighted_by_cheif_beige')}}</span>
                                  </span>


                            </v-btn>

                            <v-row>
                              <v-col cols="12" class="text-right">

                                  <v-btn outlined flat tile color="primary" @click="clearfoodstatus" style="font-size:10px;border:none;">{{$t('zz_clear_status')}}</v-btn>

                              </v-col>
                            </v-row>


                      </v-expansion-panel-content>
                  </v-expansion-panel>

                </v-expansion-panels>

                <v-expansion-panels
                v-model="paneldiet"
                multiple
                >

                    <v-expansion-panel class="mt-3" v-if="!data.sepretor">
                      <v-expansion-panel-header style="color:#fe5800;background:transparent;border-bottom:2px solid #fe5800;"><strong >{{$t('zz_diet_type')}}</strong>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>


                          <v-row >
                              <v-col v-for="(diet,index) in diets" :key="index" cols="4" md="4" sm="4" class="">

                                    <!-- <v-btn
                                    block
                                    text
                                    :class="diet.selected?'red--text':''"
                                    class="text-left"
                                    @click="diet.selected=!diet.selected" > -->
                                      <!-- <v-avatar tile height="24" width="24" left  >
                                          <v-img  :src="diet.photo" class="mr-5"></v-img>{{diet.name}}
                                      </v-avatar> -->
                                      <v-btn
                                      block
                                      tile
                                      height="70"
                                      :outlined="diet.selected?false:true"
                                      color="primary"
                                      class="text-center"
                                      @click="diet.selected=!diet.selected"
                                      style="font-size:10px">
                                      <div style="font-size:9px;" class="d-flex" justify="center">
                                        <span class="ml-auto mr-auto">
                                        <img  :src="diet.photo" class="" width="36" style="margin-bottom:8px"/><br>
                                        <p v-html="diet.name"></p></span>
                                      </div>

                                      <input type="checkbox" :name="'diets['+index+']'" v-model="diet.selected"  :value="diet.id" class="d-none"/>
                                  </v-btn>
                              </v-col>
                          </v-row>

                      </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>

            </v-col>

            <v-col cols="12" md="4" class="pb-0 pt-0">



                <v-expansion-panels
                  v-if="!data.sepretor"
                  v-model="panel2"
                  multiple

                >
                  <v-expansion-panel>
                      <v-expansion-panel-header style="color:#fe5800;background:transparent;border-bottom:2px solid #fe5800;"><strong >{{$t('zz_allergens')}}</strong>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>


                          <v-row >
                            <v-col  v-for="(allergen,index) in allergens" :key="index" cols="4" md="4" sm="4">
                              <v-btn
                                block
                                tile
                                height="70"
                                :outlined="allergen.selected?false:true"
                                color="primary"
                                class="text-center"
                                @click="allergen.selected=!allergen.selected"
                                align="center"
                              >
                              <div style="font-size:9px;" class="d-flex" justify="center">
                                  <span class="ml-auto mr-auto">
                                  <img  :src="allergen.image" class="" width="36" style="margin-bottom:8px"/><br>
                                  <p v-html="allergen.name"></p></span>
                              </div>


                                <input
                                  type="checkbox"
                                  :name="'allergens['+index+']'"
                                  v-model="allergen.selected"
                                  :value="allergen.id"
                                  class="d-none"
                                />
                              </v-btn>
                              <!-- <v-btn
                                block
                                tile
                                height="70"
                                :outlined="allergen.selected?false:true"
                                color="primary"
                                class="text-center"
                                @click="allergen.selected=!allergen.selected"
                                align="center"
                              >
                                <div style="font-size:9px;" class="d-flex text-center" justify="center">
                                  <span class="ml-auto mr-auto">
                                    <img :src="allergen.image" class="" width="36" style="margin-bottom:8px"/>
                                    {{allergen.name}}
                                  </span>
                                </div>

                                <input
                                  type="checkbox"
                                  :name="'allergens['+index+']'"
                                  v-model="allergen.selected"
                                  :value="allergen.id"
                                  class="d-none"
                                />
                              </v-btn> -->
                            </v-col>
                          </v-row>


                      </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>


                <v-expansion-panels
                v-model="panelmeat"
                v-if="!data.sepretor"
                multiple
                >


                  <v-expansion-panel class="mt-3">

                    <v-expansion-panel-header style="color:#fe5800;background:transparent;border-bottom:2px solid #fe5800;"><strong >{{$t('zz_meat')}}</strong></v-expansion-panel-header>
                    <v-expansion-panel-content>

                        <!-- <v-row>
                          <v-col class="pa-0"  cols="4" md="4" sm="4">
                            <v-btn block tile style="font-size:10px;"  :color="meattype=='meat'?'#7697a1':''" @click="changemeattype('meat')">Meat</v-btn>
                          </v-col>
                          <v-col class="pa-0"  cols="4" md="4" sm="4">
                            <v-btn block tile style="font-size:10px;" :color="meattype=='poultry'?'#7697a1':''"  @click="changemeattype('poultry')">Poutry</v-btn>

                          </v-col>
                          <v-col class="pa-0"  cols="4" md="4" sm="4">
                            <v-btn block  tile style="font-size:10px;" :color="meattype=='animal'?'#7697a1':''" @click="changemeattype('animal')">Animal Product</v-btn>

                          </v-col>
                        </v-row>   -->
                        <v-row  align="center">
                          <v-col v-for="(meat,index) in meats" :key="index" cols="4" md="4" sm="4">
                            <v-btn
                              block

                              tile
                              height="70"
                              :outlined="meat.selected?false:true"
                              color="primary"
                              class="text-center"
                              @click="meat.selected=!meat.selected"
                              align="center"
                            >

                              <div style="font-size:9px;" class="d-flex" justify="center">
                                <span class="ml-auto mr-auto">
                                <img  :src="meat.image" class="" width="36" style="margin-bottom:8px"/><br>
                                {{meat.name}}</span>
                            </div>

                              <input
                                type="checkbox"
                                :name="'meats['+index+']'"
                                v-model="meat.selected"
                                :value="meat.id"
                                class="d-none"
                              />
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row v-show="meattype=='poultry'" align="center">
                          <v-col v-for="(poultry,index) in poultries" :key="index" cols="12" md="4" sm="4">
                            <v-btn
                              block
                              text
                              align="center"
                              :color="poultry.selected?'red':''"
                              class="text-left"
                              @click="poultry.selected=!poultry.selected"
                            >

                              <span> <img :src="poultry.image" class="mr-3" width="24"/>
                                {{poultry.name}}</span>

                              <input
                                type="checkbox"
                                :name="'poultrys['+index+']'"
                                v-model="poultry.selected"
                                :value="poultry.id"
                                class="ml-auto"
                              />
                            </v-btn>
                          </v-col>
                        </v-row>

                        <v-row v-show="meattype=='animal'">
                          <v-col cols="12" md="12" sm="12">
                              Please state is any animal related products are used in preparing this dish, this is important for both Vegetarians, Vegans and certain religious faiths such as Sikhs & Buddhists<br> <a href="#" style="color:#fe5800">Click Here</a> for more information & Guidance
                          </v-col>
                          <v-row >
                            <v-col cols="6" md="6" sm="6" class="pr-0">
                              <v-btn  block tile :color="typeanimal?'primary':''" @click="typeanimal=1">Yes</v-btn>
                            </v-col>
                            <v-col cols="6" md="6" sm="6" class="pl-0">
                              <v-btn  block tile :color="!typeanimal?'primary':''" @click="typeanimal=0">No</v-btn>

                            </v-col>
                          </v-row>
                        </v-row>

                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
          </v-row>



          <!-- <v-card class="pa-3 mb-3">
            <v-row>
              <v-col cols="12" md="12" sm="12">
                <h3 class="text-center title red--text" color>Allergens</h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col v-for="(allergen,index) in allergens" :key="index" cols="12" md="4" sm="4">
                <v-btn
                  block
                  :color="allergen.selected?'red':''"
                  class="text-left"
                  @click="allergen.selected=!allergen.selected"
                >
                  <v-avatar tile height="24" width="24" left>
                    <v-img :src="allergen.image" class="mr-5"></v-img>
                    {{allergen.name}}
                  </v-avatar>
                  <input
                    type="checkbox"
                    :name="'allergens['+index+']'"
                    v-model="allergen.selected"
                    :value="allergen.id"
                    class="d-none"
                  />
                </v-btn>
              </v-col>
            </v-row>
          </v-card> -->

          <!-- <v-card class="pa-3 mb-3">
                <v-row>
                  <v-col cols="12" md="12">
                    <h4 class="title">Food Item Images</h4>
                  </v-col>
                </v-row>



                <v-card elevation="3" class="pa-3 mb-3">

                    <v-row>
                      <v-col  md="12" cols="12">
                          <h2>Gallery Images</h2>
                      </v-col>
                      <v-col v-for="(item,index) in data.gallery" :key="index" md="3" cols="4" class="img_wrp mb-3">
                          <img :src="item.imageurl" width="" style="max-width:100%;" class="imgResponsiveMax" append-icon="mdi-close-box-outline"/>
                          <v-icon class="close" @click="delelteImage(index)">mdi-close-box-outline</v-icon>
                      </v-col>
                    </v-row>
                    <v-row >
                           <v-col cols="12" md="12">
                        <v-file-input name="imggallery[]"  chips multiple accept="image/*" label="Upload Multiple Image"></v-file-input>
                      </v-col>

                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12" sm="12">
                        <v-btn class="add " color="primary" @click="addgallery">Add Gallery</v-btn>
                      </v-col>
                    </v-row>

                  </v-card>

          </v-card> -->

          <!-- <v-divider></v-divider>
            <div class="my-3">
                <v-btn color="primary" block large @click="update">Update</v-btn>
            </div> -->
        </v-form>
      </v-card-text>

      <v-footer fixed  >
        <v-col
            class="text-center"
            cols="12">
          <v-btn color="primary" block large @click="update">{{$t('zz_update')}}</v-btn>
        </v-col>
      </v-footer>

    </v-card>

    <v-dialog v-model="descriptiondialog" persistent max-width="650px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
            >
            Open Dialog
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">Item Description Translation</span>
            </v-card-title>

            <v-form v-model="valid" enctype="multipart/form-data" id="editbusinessdesccription">

                <div v-if="businessdescriptiondata.length>0">

                    <!-- <div v-for="(businessdescription,index) in businessdescriptiondata" :key="index">  -->
                    <div v-for="(item, index) in itemdescription" :key="index" align="center">

                        <v-card-text>
                            <v-container>
                                <v-row>



                                    <v-col cols="12" sm="12">
                                        <!-- <v-select
                                        v-model="businessdescription.languagecode"
                                        :items="languagelist"
                                        label="Select Language"
                                        item-text="name"
                                        item-value="value"
                                        :name="'businessdescriptionlanguagecodearr['+index+']'"
                                        required
                                        ></v-select> -->


                                        <v-autocomplete
                                        label="Select Language"
                                        v-model="item.languagecode"
                                        :name="'businessdescriptionlanguagecodearr['+index+']'"
                                        item-text="name"
                                        item-value="languagecode"
                                        :items="lang"
                                        >

                                        </v-autocomplete>




                                    </v-col>
                                    <v-col cols="12" sm="12">

                                        <!-- <v-textarea
                                        v-model="businessdescription.description"

                                        label="Business Description"
                                        :name="'businessdescriptiontranslatorarr['+index+']'"

                                        ></v-textarea> -->

                                        <v-textarea

                                        v-model="item.description"
                                        :name="'businessdescriptiontranslatorarr['+index+']'"
                                        label="Business Description"
                                        >

                                        </v-textarea>





                                    </v-col>
                                </v-row>
                            </v-container>
                            <!-- <small>*indicates required field</small> -->
                        </v-card-text>

                    </div>
                      <v-card-text>
                        <v-row>
                            <v-col cols="12" class="text-right">
                                <v-btn color="primary" tile class="ml-auto  font-weight-bold" @click="addtranslator"><v-icon class="mr-5">mdi-plus</v-icon>Add New Translation</v-btn>
                            </v-col>
                        </v-row>
                      </v-card-text>


                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="backtobusiness()">Close</v-btn>
                        <v-btn color="blue darken-1" text @click="updatedescription()">Save</v-btn>
                    </v-card-actions>

                </div>
                <div v-else>
                        <v-card-text>
                            <v-container>
                                <v-row>



                                    <v-col cols="12" sm="12">
                                        <!-- <v-select
                                        v-model="businessdescriptionlanguagecode"
                                        :items="languagelist"
                                        label="Select Language"
                                        item-text="name"
                                        item-value="value"
                                        required
                                        ></v-select> -->
                                        <v-select
                                        v-model="businessdescriptionlanguagecode"
                                        :items="lang"
                                        label="Select Language"
                                        item-text="name"
                                        item-value="languagecode"
                                        required
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="12">

                                        <v-textarea
                                        v-model="businessdescriptiontranslator"
                                        name="businessdescriptiontranslator"
                                        label="Business Description"

                                        ></v-textarea>

                                    </v-col>
                                </v-row>
                            </v-container>
                            <!-- <small>*indicates required field</small> -->
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="backtobusiness()">Close</v-btn>
                            <v-btn color="blue darken-1" text @click="createdescription()">Save</v-btn>
                        </v-card-actions>
                </div>
            </v-form>
        </v-card>
    </v-dialog>

  </v-app>
</template>
<script>
import Vue from "vue";
import VeeValidate from "vee-validate";
import Editor from '@tinymce/tinymce-vue'

import { Cropper } from 'vue-advanced-cropper'

Vue.use(VeeValidate);
export default {
  props: {
    source: String
  },
  data: () => ({
      lcode:"",
      lphoto:"",
      descriptiondialog:false,
      businessdescriptiondata:[],
      businessdescriptionlanguagecode:"",
      businessdescriptionlanguagecodearr:[],
      businessdescriptiontranslatorarr:[],
      desccriptiontype:"",
      businessdescriptiontranslator:"",
      languagelist:[{name:"English",value:"en"},
                    {name:"Spanish",value:"es"},
                    {name:"French",value:"fr"},
                    {name:"German",value:"de"},
                    {name:"Russian",value:"ru"},],
    e3: 0,
    e31: true,
    mainimguploading:false,
    overlay: false,

    editorData: '',
    editorConfigDescription: {height: 200,
         menubar: false,
        //  plugins: [
        //    'advlist autolink lists link image charmap print preview anchor',
        //    'searchreplace visualblocks code fullscreen',
        //    'insertdatetime media table paste code wordcount autoresize'
        //  ],
         toolbar:
           ' bold italic | alignleft aligncenter alignright alignjustify'
    },
    paneldiet:[0],
    panelpromotion:[0],
    panelmeat:[0],
    panelprice:[0,1,2],
    paneldish:[0,1,2],
    panel2:[0,1,2],
    panelphoto:[0],
    typeanimal:0,
    meattype:'meat',
    outlined_meat:'outlined',
    outlined_poultry:'outlined',
    outlined_animal:'outlined',

    foodstatus:'Basic',
    logo: require("@/assets/cutlery.png"),
    retImg:require("@/assets/rectangle-f.svg"),
    chefImg:require('@/assets/rectangle-c.svg'),
    addphoto: require("@/assets/addphoto.svg"),

    data:[],
    department_id:0,
    departments: [],
    poultries:[],
    btnColor:"",
    course_id:"",
    valid:true,
    counter: 0,
    title:'',
    subtitle:'',
    description:'',
    showonmenu:true,
    sepretor:false,

    courseitem:[{'id':'','course':'','special':'','price':'','size':''}],

    itemdescription:[{'id':'','languagecode':'','description':'','business_id':'','item_id':''}],
    courses:[],
    meats:[],

    diets:[],

    allergens:[],

    business_id:0,
    chilli:0,
    uploadedimage:null,
    im:'https://api.juzzap.com/storage/2372/artur-rutkowski-GdTLaWamFHw-unsplash.jpg',
    image:null,
    coordinates:
    {
				width: 0,
				height: 0,
				left: 0,
				top: 0
    },
    business:"",
    galleries:[{'imageurl':''}],
    imageurl:'',
    imggallery:[],
    files: [],
    itemid:"",
    bgallery:[],
    gallery:[],
    drinkitems:[],
    drinkitm:[],
    drinkitms:[],
    paneldrink:[0,1],
    uploadmainimg:null,
    datadescription:[],
    lang: [],
    translationlanguages:[],
    languagetranslations:[],
  }),
  components: {
    'editor': Editor,

		Cropper
	},
  created()
  {

    console.log("item id "+this.$route.params.id);
    if(this.$route.params.id)
    {
        this.itemid=this.$route.params.id;
    }

    this.storeBusiness=JSON.parse(localStorage.getItem('business'));

    this.business_id=this.storeBusiness.id;

    // if(this.$route.params.business_id)
    // {
    //     this.business_id=this.$route.params.business_id;
    // }

    this.$http
    .get(this.$apidomain+"businessdata/"+this.business_id)
    .then(res => {
    if(res.data.success==0)
    {
        this.$router.push({name:'businesslistnew'});
    }
        this.business = res.data.businesses;

        this.lcode=res.data.businesses.lcode;

        this.lphoto=res.data.businesses.lphoto;

        this.translationlanguages=res.data.businesses.translationlanguages;
    })
    .catch(err => {
        console.log(err.response);
    });

    this.fetchDepartments();
    this.fetchCourse();
    this.meatlist();
    this.fetchdiet();
    this.fetchAllergens();
    this.fetchdata();
    this.poultrylist();
    this.fetchDrinkItems();
    this.fetchbusinessdescription();
    this.fetchLang();

  },
  methods:
  {
    fetchLang()
    {
        this.$http
        .get(this.$apidomain+"languageslist")
        .then(res => {
        this.lang = res.data.languages;
        })
        .catch(err => {
        console.log(err.response);
        });
    },
    createdescription()
    {
        let th = this;
        if (this.$validator.validateAll())
        {

            let fd = new FormData(document.getElementById("editbusinessdesccription"));

            fd.append('type','update');

            fd.append('languagecode',th.businessdescriptionlanguagecode);

            fd.append('businessdescription',th.businessdescriptiontranslator);

            this.$http
            .post(this.$apidomain+"createitemdescription/"+ this.business_id+"/"+this.itemid, fd)
            .then(res => {
            if(res.data.success)
            {
                this.descriptiondialog=false;
                this.fetchdata();
            }
            else
            {
                let errmsg=[];
                for(var prop in res.data.errors){
                    errmsg.push(res.data.errors[prop][0]);
                }
                this.overlay=false;
                alert(errmsg[0]);
                this.descriptiondialog=false;


            }
            })
            .catch(err => {
                console.log(err.response);
                this.overlay=false;
            });
        }
    },

    updatedescription()
        {
            let th = this;
            if (this.$validator.validateAll())
            {

                let fd = new FormData(document.getElementById("editbusinessdesccription"));

                fd.append('type','update');

                fd.append('itemdescription',JSON.stringify(this.itemdescription));

                // fd.append('languagecode',th.businessdescriptionlanguagecodearr);

                // fd.append('businessdescription',th.businessdescriptiontranslatorarr);

                this.$http
                .post(this.$apidomain+"updateitemdescription/"+ this.business_id+"/"+this.itemid, fd)
                .then(res => {
                if(res.data.success)
                {
                    this.descriptiondialog=false;
                    this.fetchdata();
                    this.fetchbusinessdescription();
                }
                else
                {
                    let errmsg=[];
                    for(var prop in res.data.errors){
                        errmsg.push(res.data.errors[prop][0]);
                    }
                    this.overlay=false;
                    alert(errmsg[0]);
                    this.descriptiondialog=false;


                }
                })
                .catch(err => {
                    console.log(err.response);
                    this.overlay=false;
                });
            }
        },

    fetchbusinessdescription()
    {
        // this.overlay=true;
        this.$http
      .get(this.$apidomain+"itemdescriptiondata/" + this.business_id+"/"+this.itemid)
      .then(res => {
        if(res.data.success==1)
        {
            this.datadescription=res.data.itemdescription;

            this.businessdescriptiondata=res.data.itemdescription;

            this.itemdescription=res.data.itemdescription;



            // this.businessdescriptiondata=res.datadescription.itemdescription;

            // this.businessdescriptionlanguagecode=res.datadescription.itemdescription.languagecode;

            // this.businessdescriptiontranslator=res.datadescription.itemdescription.description;

            // this.overlay=false;


        }
        else
        {

            // this.overlay=false;




          // console.log(res.data.businesses);
        }
      })
      .catch(err => {
        console.log(err.response);
      });
    },
    backtobusiness()
    {
        this.descriptiondialog=false;

    },
    translator()
    {
        this.descriptiondialog=true;
    },
    chiliclear()
    {
      this.data.chillispice=0;
    },
    clearfoodstatus()
    {
      this.foodstatus='';
    },
    changemeattype(meattype)
    {
      this.meattype=meattype;
      if(this.meattype=='meat')
      {
        this.outlined_meat='';
        this.outlined_poultry='outlined';
        this.outlined_animal='outlined';
      }else if(this.meattype=='poultry')
      {
        this.outlined_meat='outlined';
        this.outlined_poultry='';
        this.outlined_animal='outlined';
      }else if(this.meattype=='animal')
      {
        this.outlined_meat='outlined';
        this.outlined_poultry='outlined';
        this.outlined_animal='';
      }
    },
    changefoodstatus(foodstatus)
    {
      this.foodstatus=foodstatus;
    },
    delelteImage(index)
    {
      this.$http
      .post(this.$apidomain+"itemdeleteimages/"+ this.itemid+'/'+index)
      .then(res => {
        this.data.gallery=res.data.gallery;
        //console.log("types "+ this.types);
      })
      .catch(err => {
        console.log(err.response);
      });
    },
    deleltemainImage()
      {
        this.$http
        .post(this.$apidomain+"itemdeletemainimage/"+ this.itemid)
        .then(res => {
            this.fetchdata();
            //this.business=res.data.business;
            //this.$router.go();
            //console.log("types "+ this.types);
        })
        .catch(err => {
            console.log(err.response);
        });
      },
    fetchdata()
    {
        this.$http
        .get(this.$apidomain+"itemData/" + this.itemid)
        .then(res => {
            this.data=res.data.items;
            this.image=this.data.image;
            this.uploadmainimg=this.data.image;
            this.courseitem=res.data.Course;

            this.drinkitems=res.data.drinkitems;

            this.foodstatus=this.data.foodstatus;
            this.business_id=res.data.items.business_id;
                // console.log(res.data.businesses);
            this.gallery=res.data.gallery;
            this.languagetranslations=res.data.items.languagetranslations;

            this.$http
            .get(this.$apidomain+"departmentList/"+this.business_id)
            .then(res => {
                    this.departments = res.data.departments;
            })
            .catch(err => {
                    console.log(err.response);
            });

            this.$http
            .get(this.$apidomain+"businessdata/"+this.business_id)
            .then(res => {
                this.business = res.data.businesses;
            })
            .catch(err => {
                console.log(err.response);
            });

        })
        .catch(err => {
            console.log(err.response);
        });
    },
    fetchDepartments()
    {
      this.$http
      .get(this.$apidomain+"departmentList/"+this.business_id)
      .then(res => {
          this.departments = res.data.departments;
      })
      .catch(err => {
        console.log(err.response);
      });
    },
    addtranslator()
    {
      this.itemdescription.push({
        'id':'',
        'languagecode':'',
        'description':'',
        'business_id':'',
        'item_id':'',
        })
    },
    add()
    {
      this.courseitem.push({
      'id':'',
      'course':'',
      'special':'',
      'price':'',
      'size':'',
      })
    },
    onChange({coordinates, canvas}) {

			this.coordinates = coordinates
			// You able to do different manipulations at a canvas
			// but there we just get a cropped image
      this.image = canvas.toDataURL();

      this.uploadmainimg=this.image;
      this.mainimguploading=false;

    },
    uploadImage(event) {
			// Reference to the DOM input element
			var input = event.target;
			// Ensure that you have a file before attempting to read it
			if (input.files && input.files[0]) {
          this.mainimguploading=true;

					// create a new FileReader to read this image and convert to base64 format
					var reader = new FileReader();
					// Define a callback function to run, when FileReader finishes its job
					reader.onload = (e) => {
							// Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
							// Read image as base64 and set to imageData
							this.uploadedimage = e.target.result;
					}
					// Start the reader job - read file as a data url (base64 format)
					reader.readAsDataURL(input.files[0]);
			}
    },
    poultrylist()
    {
      this.$http
      .get(this.$apidomain+"itempoultryList/"+this.itemid)
      .then(res => {
          this.poultries = res.data.poultrys;

          // this.selectedmeats = this.meats.map(() => false);

      })
      .catch(err => {
          console.log(err.response);
      });
    },
    meatlist()
    {
            this.$http
            .get(this.$apidomain+"itemmeatListpwa/"+this.itemid)
            .then(res => {
                this.meats = res.data.meats;

               // this.selectedmeats = this.meats.map(() => false);

            })
            .catch(err => {
                console.log(err.response);
            });

    },

    fetchCourse()
    {
      let $url='';
      //this.$apidomain+"courselist"
      $url=this.$apidomain+"itemCourseListpwa/"+this.itemid+'/'+this.business_id;
            this.$http
            .get($url)
            .then(res => {
                this.courses = res.data.course;
            })
            .catch(err => {
                console.log(err.response);
            });
    },
    fetchAllergens()
    {
        this.$http
        .get(this.$apidomain+"itemallergenslist/"+this.itemid)
        .then(res => {
            this.allergens = res.data.allergens;
        })
        .catch(err => {
            console.log(err.response);
        });
    },
    fetchdiet()
    {
            this.$http
            .get(this.$apidomain+"itemdietListpwa/"+this.itemid)
            .then(res => {
                this.diets = res.data.diets;
            })
            .catch(err => {
                console.log(err.response);
            });
    },
    fetchDrinkItems()
    {
      // drinkitems
      this.$http
      .get(this.$apidomain+"itemDrinkList/"+this.itemid+'/'+this.business_id)
      .then(res => {
          this.drinkitm = res.data.drinkitems;
      })
      .catch(err => {
        console.log(err.response);
      });
    },
    addgallery()
    {
         this.galleries.push({'imageurl':''})
    },
    dataURLtoFile(dataurl, filename)
    {

            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);

            while(n--){
                u8arr[n] = bstr.charCodeAt(n);
            }

            return new File([u8arr], filename, {type:mime});
    },
    update()
    {
        let th = this;
        if (this.$validator.validateAll())
        {
            let fd = new FormData(document.getElementById("edititem"));

            th.crs=JSON.stringify(this.courseitem);

            console.log('citem '+JSON.stringify(this.courseitem)+' crsid '+th.crs);

            fd.append('citem',JSON.stringify(this.courseitem));
            fd.append('languagetranslations',JSON.stringify(this.languagetranslations));


            fd.append('business_id',this.business_id);

            if(this.data.showonmenu)
            {
               fd.append('showonmenu',1);
            }
            else
            {
              fd.append('showonmenu',0);

            }

            if(this.data.sepretor)
            {
               fd.append('sepretor',1);
            }
            else
            {
              fd.append('sepretor',0);

            }

            fd.append('foodstatus',this.foodstatus);


            fd.append('chillispice',this.data.chillispice);

            fd.append('description',this.data.description);

            fd.append('drinkitems',JSON.stringify(this.drinkitems));


            this.overlay=true;


            if(this.uploadedimage!=null){
                fd.append('imagea',this.dataURLtoFile(this.image,document.getElementById('itemimage').files[0].name));
            }
            this.$http
            .post(this.$apidomain+"updateItem/"+this.itemid, fd)
            .then(res => {
                if(res.data.success==1)
                {
                  this.overlay=false;

                   // this.$router.push("/agent/itemlist/"+this.business_id);
                  //this.$router.push("/businessfoodlist/"+this.business_id);
                 // this.$router.push({name:'businessfoodlist'});
                 this.$router.push({name:'food',params:{tag:this.storeBusiness.businesscode,key:''}});
                 // this.$router.push({name:'businessfoodlist'});

                }

                else if(res.data.success==3)
                {
                  alert('Hey, It looks like you have not selected which course this item belongs too…');
                  this.overlay=false;
                  let inputID = document.querySelector(".course_container input").id;
                  //let labelID = document.querySelector(".course_container label").getAttribute('for');
                  //alert(labelID);
                  //this.course_id[0].focus();
                  document.getElementById(inputID).parentElement.parentElement.parentElement.parentElement.setAttribute( 'class', 'v-input--is-focused v-input--is-focused theme--light v-text-field v-text-field--is-booted primary--text' );
                  //document.getElementById(labelID).parentElement.parentElement.parentElement.parentElement.setAttribute( 'class', 'v-label--active theme--light primary--text' );
                // document.getElementById(inputID).parentElement.parentElement.parentElement.parentElement.focus();

                  //document.getElementById(inputID).parentElement.parentElement.parentElement.focus();
                  //document.getElementsByClassName('course_container').find('input').css('v-input--is-focused');
                  //document.querySelector('input.course-control[type=text]').focus();

                }
                else if(res.data.success==4)
                {
                  alert('Hey, It looks like you have not selected which diets this item belongs too…');
                  this.overlay=false;

                }
                else
                {
                    this.overlay=false;

                    let errmsg=[];
                    for(var prop in res.data.errors){
                        errmsg.push(res.data.errors[prop][0]);
                    }
                    alert(errmsg[0]);
                }
            })
            .catch(err => {
                    this.overlay=false;

                    console.log(err.response);
            });
        }
    }
  }
};
</script>
<style >
.cropper {
  border: solid 1px #eee;
  height: 300px;
  width: 100%;
}

.p-10 {
  padding: 10px;
}
.pwa-content {
  margin-top: -63px;
}
#mainhomecontainer.container {
  width: 100%;
  max-width: 100%;
}
#mainhomecontainer.container .heading {
  color: #fff;
}
.topbg {
  background: #fe5800;
}
.promotionbtn .v-btn__content{
  justify-content: left;
  padding: 12px 0px;
}

.statheadings{
font-weight: 800;
}
.statdata{
  font-weight: 400;
}
</style>
